export const ENV =
  window.location.href.includes('dev') ||
  window.location.href.includes('localhost')
    ? '.dev'
    : '';

export const REACT_APP_SSO_URL = `https://auth${ENV}.doctoroncall.com.my`;
